/* eslint @okta/okta-ui/no-specific-methods: 0 */
import Handlebars from 'handlebars';
import _ from './underscore-wrapper';

/**
 * @class module:Okta.internal.util.TemplateUtil
 * @hideconstructor
 */
export default /** @lends module:Okta.internal.util.TemplateUtil */ {
  /**
   * Compiles a Handlebars template
   * @static
   * @method
   */
  // TODO: This will be deprecated at some point. Views should use pre-compiled templates
  tpl: _.memoize(function (tpl) {
    /* eslint @okta/okta-ui/no-specific-methods: 0 */
    return function (context) {
      return Handlebars.compile(tpl)(context);
    };
  })
};



// WEBPACK FOOTER //
// ./node_modules/@okta/courage/src/util/TemplateUtil.js


// WEBPACK FOOTER //
// webpack:///node_modules/@okta/courage/src/util/TemplateUtil.js